import $ from 'jquery';
import Swiper, { Pagination, Navigation } from 'swiper';

function initTestimonialsSlider() {
  $(function () {
    if ($('.slider-block').length <= 0) {
      return;
    }

    $('.testimonials-slider').each(function () {
      const slider = $(this).find('.slider-block');
      const pagination = $(this).find('.swiper-pagination');
      const arrows = $(this).find('.slider-arrows');

      new Swiper(slider.get(0), {
        modules: [ Navigation],
        slidesPerView: 1, // Default value for large screens
        spaceBetween: 40,
        loop: true,
        
        navigation: {
          nextEl: slider.find('.swiper-button-next').get(0),
          prevEl: slider.find('.swiper-button-prev').get(0),
        },
        watchOverflow: false, // Automatically hide pagination if all slides fit
        breakpoints: {
          576: {
            slidesPerView: 1, // Mobile
          },
          768: {
            slidesPerView: 1, // Tablet
          },
          1024: {
            slidesPerView: 1, // Desktop
          },
        },
      });
    });
  });
}

export { initTestimonialsSlider };
